<template>
  <div class="app-container-wrapper">
    <head-container>
      <breadcrumb />
    </head-container>

    <div class="app-container">
      <div class="content-left card no-padding-bottom">
        <el-scrollbar>
          <div v-if="subCompanyTree.length" class="section">
            <div class="section-content">
              <div class="m-b-10 text-third-info">
                下级企业（默认展示子一级）
              </div>

              <el-tree
                ref="companyTree"
                :data="subCompanyTree"
                :props="{
                  label: 'companyName',
                  isLeaf: 'isLeaf'
                }"
                node-key="companyId"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                @node-click="data => selectSubCompany(data, true)"
              >
                <template v-slot="{ node, data }">
                  <div class="flex-1 flex col-center text-ellipsis">
                    <i
                      v-if="data.companyId !== data.rootCompany.companyId"
                      class="iconfont icon-organization m-r-4"
                    ></i>
                    <div
                      class="text-ellipsis tree-text flex-1"
                      :class="{
                        active: currentNode.companyId === node.data.companyId
                      }"
                      :title="`${node.data.companyName}`"
                    >
                      {{ node.data.companyName }}
                    </div>
                    <!--显示下级子公司树-->
                    <el-popover
                      v-if="
                        data.rootCompany &&
                          data.rootCompany.subordinateCompanyCount
                      "
                      placement="right"
                      width="400"
                      height="596"
                      trigger="hover"
                    >
                      <el-scrollbar
                        style="height: 400px"
                        class="left-content-popover"
                      >
                        <el-tree
                          :props="{ label: 'name', children: 'children' }"
                          :data="subCompanyUnderlingTree"
                          :expand-on-click-node="false"
                          :check-on-click-node="true"
                          :default-expand-all="true"
                          class="tree"
                          @node-click="selectSubUnderlingComponent"
                        >
                          <template v-slot="{ node }">
                            <div class="text-ellipsis" :title="node.label">
                              {{ node.label }}
                            </div>
                          </template>
                        </el-tree>
                      </el-scrollbar>

                      <span
                        slot="reference"
                        class="m-l-6 text-primary"
                        @mouseenter="
                          getSubCompanyUnderlingList(data.rootCompany)
                        "
                      >
                        更多
                      </span>
                    </el-popover>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <div class="content-right card search">
        <base-section-title title="文档资料" />
        <el-tabs v-model="activeName" class="m-t-24" @tab-click="handleSearch">
          <el-tab-pane
            v-for="tab in tabList"
            :key="tab.name"
            :label="tab.label"
            :name="tab.name"
          />
        </el-tabs>

        <el-form inline size="small" label-suffix="：">
          <el-form-item label="名称" prop="documentName">
            <el-input
              v-model.trim="filterForm.documentName"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="发布人" prop="releaserEmpName">
            <el-input
              v-model.trim="filterForm.releaserEmpName"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="类型" prop="documentType">
            <tree-select
              v-model="filterForm.documentType"
              class="tree-select"
              :options="[{ label: '全部', value: '' }, ...jxicDocTypeDictTree]"
              :normalizer="normalizer"
              placeholder="请选择"
              :disable-branch-nodes="true"
              append-to-body
              no-options-text="暂无数据"
              :z-index="998"
            />
          </el-form-item>
          <el-form-item label="发布企业" prop="companyName">
            <el-input
              v-model.trim="filterForm.companyName"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="handleSearch">
              查询
            </el-button>
            <el-button size="small" @click="handleReset">
              重置
            </el-button>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="m-t-24" @click="openUploadDoc">
          上传文档
        </el-button>

        <jczh-table-content
          class="m-t-24"
          :data="list"
          :option="tableOption"
          pagination
          :total="total"
          :page.sync="page"
          :limit.sync="size"
        >
          <template v-slot:documentType="{ row }">
            <span v-if="row.documentType === jxicDocTypeDict.DOCUMENT.value">
              {{
                jxicOtherDocTypeDict.translate(row.otherInformationType)
                  .label || '-'
              }}
            </span>
            <span v-else>
              {{ jxicDocTypeDict.translate(row.documentType).label || '-' }}
            </span>
          </template>
          <template v-slot:operate="{ row }">
            <div class="flex">
              <el-popover
                v-if="hasDocRight(row, 1)"
                placement="bottom"
                width="300"
                trigger="click"
              >
                <div>
                  <div class="text-third-info m-b-10">选择移动分类</div>
                  <el-tree
                    :data="jxicDocTypeDictTree"
                    node-key="value"
                    :props="{ label: 'label', children: 'children' }"
                    :default-expand-all="true"
                    @node-click="
                      (value, data, node) =>
                        updateJxicDocument(row, value, data, node)
                    "
                  />
                </div>

                <el-button slot="reference" type="text">移动</el-button>
              </el-popover>

              <upload-authorization-file
                v-model="row.attachmentIds[0]"
                upload-mode="fileId"
                :preview-api="previewJxicDocumentApi"
                :download-api="downloadJxicDocumentApi"
                :props-data="{
                  uploadMode: 'fileId',
                  disabled: true,
                  fileListHiddenControl: { hiddenFileName: true }
                }"
                :request-params="{
                  documentId: row.documentId,
                  attachmentId: row.attachmentIds[0],
                  isRelease: true
                }"
                :translate-data="{
                  downloadTranslate: 'documentFileUrl'
                }"
              />
              <el-button
                v-if="hasDocRight(row, 2)"
                type="text"
                class="m-l-10"
                @click="removeJxicDocument(row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </jczh-table-content>
      </div>

      <!-- 资料上传弹窗 -->
      <el-dialog
        title="资料上传"
        class="dialog"
        :visible.sync="uploadDocVisible"
        :close-on-click-modal="false"
        :before-close="closeUploadDoc"
      >
        <el-form
          ref="uploadDocForm"
          :model="uploadDocForm"
          :rules="uploadDocFormRules"
          label-width="120px"
          label-suffix="："
        >
          <el-form-item label="类型" prop="documentType">
            <tree-select
              v-model="uploadDocForm.documentType"
              class="tree-select"
              :options="jxicDocTypeDictTree"
              :normalizer="normalizer"
              placeholder="请选择"
              :disable-branch-nodes="true"
              :auto-select-descendants="false"
              append-to-body
              no-options-text="暂无数据"
              :z-index="999999999"
            />
          </el-form-item>
          <el-form-item label="文件" prop="docFileId">
            <upload-authorization-file
              v-model="uploadDocForm.docFileId"
              upload-mode="fileId"
              :preview-api="previewUnReleaseJxicDocumentApi"
              :download-api="downloadUnReleaseJxicDocumentApi"
              :props-data="{
                uploadMode: 'fileId',
                limit: 1,
                fileSize: 1000
              }"
              :request-params="{
                attachmentId: uploadDocForm.docFileId,
                isRelease: false
              }"
              :translate-data="{
                downloadTranslate: 'documentFileUrl'
              }"
              @change="handleFileChange"
            >
              <template v-slot:tip>
                <div class="important-tip m-l-10">
                  请上传pdf/doc/docx/xls/xlsx/ppt/pptx类型文件，单个文件最大1000MB；仅支持上传1份文件
                </div>
              </template>
            </upload-authorization-file>
          </el-form-item>
        </el-form>
        <template v-slot:footer>
          <div>
            <el-button @click="closeUploadDoc">取消</el-button>
            <el-button type="primary" @click="confirmUploadDoc">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 组件
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb.vue'
import HeadContainer from '@/components/common/HeadContainer.vue'
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// mixin
import listFilterMixin from '@/mixins/list-filter-mixin'
// 接口
import {
  addJxicDocumentApi,
  downloadJxicDocumentApi,
  downloadUnReleaseJxicDocumentApi,
  getJxicDocumentPageApi,
  previewJxicDocumentApi,
  previewUnReleaseJxicDocumentApi,
  removeJxicDocumentApi,
  updateJxicDocumentApi
} from '@/api/jxic-document'
// 字典
import {
  jxicDocTypeDict,
  jxicOtherDocTypeDict,
  isDeletedDict
} from '@/dictionary/jxic-document'
import { requiredRule } from '@/utils/form-validate'
import { mapGetters, mapState } from 'vuex'
import { workbenchServiceDict } from '@/dictionary/system'
import {
  getSubCompanyListApi,
  getSubCompanyUnderlingListApi
} from '@/api/company'
import { transListToTree } from '@/utils/company'
import { cloneDeep } from 'lodash'

/**
 * 省投文档资料页面
 */
export default {
  name: 'JxicDocument',
  components: {
    UploadAuthorizationFile,
    HeadContainer,
    Breadcrumb,
    BaseSectionTitle,
    TreeSelect
  },
  mixins: [listFilterMixin],
  data() {
    return {
      jxicDocTypeDict,
      jxicOtherDocTypeDict,

      // -------------- 子公司 --------------
      subCompanyTree: [], // 一级子公司及部门数据树，可能为搜素过滤后的数据
      subCompanyUnderlingTree: [],
      currentNode: {},
      isSubCompany: false, // 是否是子公司

      activeName: 'all',
      tabList: [
        { label: '全部', name: 'all' },
        { label: '我上传的', name: 'my' },
        { label: '回收站', name: 'recycle' }
      ],
      filterForm: {
        // 文档名称
        documentName: '',
        // 发布人
        releaserEmpName: '',
        // 类型
        documentType: null,
        // 发布企业
        companyName: '',
        // 所属公司id
        companyId: ''
      },
      list: [],
      total: 0,
      // 上传文档弹窗显示控制
      uploadDocVisible: false,
      // 上传文档表单
      uploadDocForm: {
        // 文档类型
        documentType: null,
        // 文档名称
        documentName: '',
        // 文档文件id
        docFileId: ''
      },
      uploadDocFormRules: {
        documentType: requiredRule('请选择文档类型', '', 'change'),
        docFileId: requiredRule('请上传文档文件', '', 'change')
      }
    }
  },
  computed: {
    ...mapState('user', ['employeeId', 'isAdmin', 'funRights']),
    ...mapState('router', ['currentWorkbench']),
    ...mapGetters('company', ['platformTitle']),

    // 是否是省投及其下属企业，且是在采购工作台
    isJxic() {
      return this.platformTitle === '江西投资集团电子采购平台'
    },

    jxicDocTypeDictTree() {
      return [
        { label: '采购平台制度', value: jxicDocTypeDict.PLATFORM_NOTICE.value },
        {
          label: '招标采购制度',
          value: jxicDocTypeDict.PURCHASE_MANAGEMENT.value
        },
        {
          label: '采购其他资料',
          value: jxicDocTypeDict.DOCUMENT.value,
          children: [
            { label: '采购项目资料', value: 4 },
            { label: '其他资料', value: 5 }
          ]
        }
      ]
    },

    // 表格配置
    tableOption() {
      if (this.activeName === 'recycle') {
        return [
          { label: '名称', prop: 'documentName' },
          {
            label: '类型',
            prop: 'documentType',
            slotName: 'documentType'
          },
          { label: '发布人', prop: 'releaserEmpName' },
          { label: '发布企业', prop: 'companyName' },
          { label: '发布时间', prop: 'releaseTime' },
          { label: '删除人', prop: 'releaserEmpName' },
          { label: '删除时间', prop: 'deleteTime' },
          { label: '操作', slotName: 'operate', minWidth: '80px' }
        ]
      } else {
        return [
          { label: '名称', prop: 'documentName' },
          {
            label: '类型',
            prop: 'documentType',
            slotName: 'documentType'
          },
          { label: '发布人', prop: 'releaserEmpName' },
          { label: '发布企业', prop: 'companyName' },
          { label: '发布时间', prop: 'releaseTime' },
          { label: '操作', slotName: 'operate', minWidth: '110px' }
        ]
      }
    }
  },

  watch: {
    uploadDocVisible: {
      handler: function(val) {},
      immediate: true
    }
  },

  created() {
    if (!this.isJxic) {
      this.$router.replace({ name: 'Homepage' })
      return
    }
    this.filterForm.documentType = this.$route.query.documentType || null
    this.getSubCompanyList()
    this.handleSearch()
  },

  methods: {
    downloadUnReleaseJxicDocumentApi,
    previewUnReleaseJxicDocumentApi,
    downloadJxicDocumentApi,
    previewJxicDocumentApi,

    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.value,
        label: node.label,
        children: node.children
      }
    },

    // ，1、自己上传的文件；2、拥有文件权限
    /**
     * 是否拥有修改（移动，删除）文件的权限
     * @param row
     * @param type 1：移动；2：删除
     * @returns {*|boolean}
     */
    hasDocRight(row, type) {
      // 移除管理员权限，需要操作则让管理员自己勾选文档管理功能
      const fileRight = this.funRights.includes('documentManagementList')

      if (type == 1) {
        return fileRight && this.activeName !== 'recycle'
      }
      if (type == 2) {
        return (
          (fileRight || this.employeeId === row.releaserEmpId) &&
          this.activeName !== 'recycle'
        )
      }

      return false
    },

    // 点击重置
    handleReset() {
      this.reset()
      this.currentNode = {}
      this.handleSearch()
    },

    // 点击重置
    getList() {
      this.epitaxy()
      const params = {
        page: this.page,
        size: this.size,
        documentName: this.filterForm.documentName,
        releaserEmpName: this.filterForm.releaserEmpName,
        companyName: this.filterForm.companyName,
        companyId: this.filterForm.companyId,
        isDeleted:
          this.activeName === 'recycle'
            ? isDeletedDict.YES.value
            : isDeletedDict.NO.value,
        releaserEmpId: this.activeName === 'my' ? this.employeeId : ''
      }
      if (
        this.filterForm.documentType === 4 ||
        this.filterForm.documentType === 5
      ) {
        params.documentType = jxicDocTypeDict.DOCUMENT.value
        if (this.filterForm.documentType === 4) {
          params.otherInformationType = jxicOtherDocTypeDict.PROJECT.value
        }
        if (this.filterForm.documentType === 5) {
          params.otherInformationType = jxicOtherDocTypeDict.OTHER.value
        }
      } else {
        params.documentType = this.filterForm.documentType
        params.otherInformationType = ''
      }
      getJxicDocumentPageApi(params)
        .then(res => {
          this.list = res.data?.records || []
          this.total = res.data?.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 打开上传资料弹窗
     */
    openUploadDoc() {
      if (this.$refs.uploadDocForm) {
        this.$refs.uploadDocForm.clearValidate()
      }
      this.uploadDocVisible = true
      this.$forceUpdate()
    },

    /**
     * 监听上传文件列表的变化
     */
    handleFileChange(list) {
      this.uploadDocForm.documentName = list[0]?.fileName
    },

    /**
     * 取消提交资料文件
     */
    closeUploadDoc() {
      this.uploadDocVisible = false
      this.$refs.uploadDocForm.resetFields()
      this.$refs.uploadDocForm.clearValidate()
    },

    /**
     * 确定提交资料文件
     */
    confirmUploadDoc() {
      this.$refs.uploadDocForm.validate(valid => {
        if (!valid) return

        const postData = {
          documentName: this.uploadDocForm.documentName,
          // documentType: this.uploadDocForm.documentType,
          attachmentIds: [this.uploadDocForm.docFileId]
        }
        if (
          this.uploadDocForm.documentType === 4 ||
          this.uploadDocForm.documentType === 5
        ) {
          postData.documentType = jxicDocTypeDict.DOCUMENT.value
          if (this.uploadDocForm.documentType === 4) {
            postData.otherInformationType = jxicOtherDocTypeDict.PROJECT.value
          }
          if (this.uploadDocForm.documentType === 5) {
            postData.otherInformationType = jxicOtherDocTypeDict.OTHER.value
          }
        } else {
          postData.documentType = this.uploadDocForm.documentType
          postData.otherInformationType = ''
        }
        const identity = workbenchServiceDict.translate(this.currentWorkbench)
          ?.platformAlias
        addJxicDocumentApi(postData, identity)
          .then(res => {
            this.$message.success('上传成功')
            this.closeUploadDoc()
            this.handleSearch()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 删除自己上传的文件
     */
    removeJxicDocument(row) {
      removeJxicDocumentApi(row.documentId)
        .then(res => {
          this.$message.success('已删除文档')
          this.handleSearch()
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    // 移动文件
    updateJxicDocument(row, value, data, node) {
      if (data.childNodes.length) return

      const params = {}
      if (value.value === 4 || value.value === 5) {
        params.documentType = jxicDocTypeDict.DOCUMENT.value
        if (value.value === 4) {
          params.otherInformationType = jxicOtherDocTypeDict.PROJECT.value
        }
        if (value.value === 5) {
          params.otherInformationType = jxicOtherDocTypeDict.OTHER.value
        }
      } else {
        params.documentType = value.value
        params.otherInformationType = 0
      }

      updateJxicDocumentApi(row.documentId, params)
        .then(res => {
          this.getList()
        })
        .catch(err => {
          this.$message.error(err?.message || '文件移动失败')
        })
    },

    // 获取一级子公司列表
    getSubCompanyList() {
      getSubCompanyListApi()
        .then(res => {
          this.subCompanyTree = (res.data || []).map(value => {
            return {
              companyId: value.companyId,
              id: value.companyId,
              companyName: value?.companyName,
              subordinateCompanyCount: value.subordinateCompanyCount,
              parentId: value.parentCompanyInfo.companyId,
              rootCompany: {
                companyId: value.companyId,
                companyName: value?.companyName,
                subordinateCompanyCount: value.subordinateCompanyCount,
                parentId: value.parentCompanyInfo.companyId
              }
            }
          })
        })
        .catch(err => {
          console.error('获取子公司列表失败', err)
          this.$message.error(err?.message || '获取子公司列表失败')
        })
    },

    /**
     * 获取子公司的下级公司
     */
    getSubCompanyUnderlingList(rootCompany) {
      getSubCompanyUnderlingListApi(rootCompany.companyId)
        .then(res => {
          const subCompanyUnderlingList = [
            ...(res.data || []),
            rootCompany
          ].map(value => {
            return {
              companyId: value.companyId,
              name: value?.companyName || value.majorName,
              companyName: value?.companyName || value.majorName,
              parentId: value?.parentInfo?.parentId || value.parentId || 0,
              rootCompany
            }
          })

          this.subCompanyUnderlingTree = transListToTree(
            subCompanyUnderlingList,
            'companyId'
          )
        })
        .catch(err => {
          this.$message.error(err?.message || '获取子公司的下属公司列表失败')
        })
    },

    /**
     * 选择下级公司的下属公司，进行替换
     */
    selectSubUnderlingComponent(data) {
      const index = this.subCompanyTree.findIndex(
        subCompanyList =>
          subCompanyList.rootCompany.companyId === data.rootCompany.companyId
      )
      if (index < 0) return
      const node = this.$refs.companyTree.getNode(
        this.subCompanyTree[index].companyId
      )
      node.parent.loaded = false
      const nodeData = cloneDeep(data)
      delete nodeData.children
      this.$set(this.subCompanyTree, index, nodeData)
      this.selectSubCompany(nodeData, true)
      node.parent.expand()
    },

    selectSubCompany(data, isSubCompany = false) {
      if (data.disabled) return
      this.currentNode = { ...data }
      this.isSubCompany = isSubCompany
      this.filterForm.companyId = this.currentNode.companyId
      this.handleSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  display: flex;
  align-items: stretch;
  flex-direction: row;
}

.content-left {
  width: 400px;

  .section-content {
    padding: 0 16px;

    &.our-company {
      margin: 0 16px;
      padding: 14px 8px;
      background-color: $primary-fifth-color;

      .tree {
        background-color: $primary-fifth-color;
      }
    }

    .add-btn {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 14px;
      border: 0;
    }

    .tree {
      ::v-deep {
        .el-tree-node {
          .el-tree-node__content {
            display: flex;
            margin-top: 6px;
            overflow: hidden;

            &:hover {
              background-color: $primary-background-color;
              color: $primary-color;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-scrollbar {
    height: calc(100% - 44px);

    .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }
}

.content-right {
  margin-left: 16px;
  margin-top: 0;
}

.tree-text {
  padding-left: 4px;
  line-height: 30px;
  &.active {
    width: 100%;
    background-color: $primary-background-color;
    color: $primary-color;
  }
}

.tree-select {
  width: 200px;

  ::v-deep .vue-treeselect__control {
    height: 32px;
  }
}
</style>
